import React from "react";
import TemplateItem from "./TemplateItem";
import {connect} from "react-redux";
import {addElement} from "../../../actions/CreateSiteActions/createSiteActions";
import { resetStep2Validation } from "../../../actions/ValidationActions/validateStep2Acitons"; 
import {ADD_TEMPLATE} from "../../../actions/types";
import DisplayMessage from "../DisplayMessage";
import DSpinner from "../CommonComponents/Spinner";
import QuotaPicker from './QuotaPicker';
import InfoTable from './InfoTable';
import Carousel from "../../CustomComponents/Carusele";
import Api from '../../../services/Api';
import TemplateTypeLogo from "../CommonComponents/TemplateTypeLogo";
import axios from 'axios';

class Templates extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            possibilities: [],
            error: null,
            isLoading: true,
        }
    }

    componentDidMount() {
        this.axiosCancelSource = axios.CancelToken.source();

        if (this.props.online != null) {
            this.getTemplates(false);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.online !== this.props.online) {
            this.axiosCancelSource.cancel();
            this.axiosCancelSource = axios.CancelToken.source();
            
            this.getTemplates(true);
            this.setState({isLoading: true})
        }
    }

    componentWillUnmount() {
        this.axiosCancelSource.cancel();
    }

    getTemplates(isUpdate) {
        //const locType = this.props.online ? LocationType.online : LocationType.onPremise;
        Api.get(`/Template?locationId=${this.props.locationObject.id}`, {
            cancelToken: this.axiosCancelSource.token
        })
        .then(res => res.data)
        .then(posts => {
                this.setState({
                    possibilities: posts,
                    error: null
                }, () => {
                    if (posts[0] != null) {
                        if (!this.props.template || isUpdate) {

                            const template = posts.filter(x => x.default).length > 0
                                ? posts.filter(x => x.default)[0].id
                                : posts[0].id;

                            this.templatePicked(template);
                        }
                    }
                });

                this.setState({isLoading: false});
            }
        ).catch((error) => {
            this.setState({error: "Could not return data from server"})
        });
    }

    templatePicked(id) {
        if (this.state.possibilities.length > 0) {
            this.props.sendElement(ADD_TEMPLATE, this.state.possibilities.filter(x => x.id === id)[0]);
            this.props.resetStep2Validation();
        }
    }

    createTemplateItems(templates)
    {
        return templates.map(x =>
            <div key={x.id} className="template-item-container">
                <TemplateItem id={x.id}
                              class={this.props.template !== null && this.props.template.id === x.id ? 'template-item-picked' : 'template-item'}
                              key={x.id}
                              online={this.props.online}
                              pick={this.templatePicked.bind(this)}
                              selected={(this.props.template !== null && this.props.template.id === x.id)}
                              default={x.default}
                              type={x.siteType}
                              name={x.name}
                              description={x.description}
                              imageUrl={x.imageUrl}
                              emphasizeInSiteCreation={x.config && x.config.emphasizeInSiteCreation}
                />
                <TemplateTypeLogo template={x} />
            </div>
        )
    }

    render() {

        if (this.props.confidentialLevel === null || this.props.confidentialLevel.length === 0) return null;
        //const warning = this.props.possibleWarning && !this.props.template ? warningIcon : null;
        const nonCustomTempl = this.createTemplateItems(this.state.possibilities.filter(x => !x.isCustom || x.isCustom));
        // const customTempl = this.state.possibilities.filter(x => x.isCustom);

        // const templComboBox = customTempl.length > 0 ?
        //     <TemplatesComboBox
        //         customTempl={customTempl}
        //         pick={this.templatePicked.bind(this)}
        //         globalTemplate={this.props.template}
        //     /> : null;

        let caruseleItems = [];
        
        nonCustomTempl.map(x => caruseleItems.push(x));

        // if (templComboBox) caruseleItems.push(templComboBox);
        /*const display = caruseleItems.length > 3 ?
                <div>
                    <Carousel children={caruseleItems}/>
                </div>
                :
                <div>
                    {nonCustomTempl}
                    {templComboBox}
                </div> ; */

        const display =   
            <div>
                <Carousel children={caruseleItems}/>
            </div>;     

        const spinner = <div className="template-spinner"><DSpinner/></div>;

        return (
            <div className='templates'>
                {this.state.isLoading ? spinner :
                    <div>
                        {this.props.online && <QuotaPicker/>}
                        <InfoTable/>
                        <div className='item-title'>Choose template for your site</div>
                        {display}
                        <DisplayMessage error={this.state.error}/>
                    </div>
                }
            </div>
        );
    }


}

const mapActionsToProps = {
    sendElement: addElement,
    resetStep2Validation
}

const mapStateToProps = state => (
    {
        online: state.newSite.OnlineLocation,
        confidentialLevel: state.newSite.Confidentiality,
        template: state.newSite.Template,
        possibleWarning: state.wizard.nextStepRequested,
        //     validationResult : state.step1Validation.TemplateValid,
        locationObject: state.newSite.Location
    }
)

export default connect(mapStateToProps, mapActionsToProps)(Templates)



// WEBPACK FOOTER //
// ./src/components/CreateSite/Step1/Templates.js